<div
  class="container"
  (click)="positionClicked($event)"
  (mousemove)="mouseMove($event)"
  (mouseup)="mouseUp($event)"
  (mouseleave)="mouseLeave($event)"
  (wheel)="scrolling($event)">
  <div class="backbone"></div>
  <div class="thumb" [style.left.px]="scrollOffset" #thumb (mousedown)="mouseDown()">
    <div class="dot"></div>
  </div>
</div>
